var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "aiHelper-slide-container" },
    [
      _c(
        "div",
        { staticClass: "slide-top flex justify-between items-center" },
        [
          _c("TitleType", { on: { change: _vm.changeConversation } }),
          _c("p", { staticClass: "icons flex" }, [
            _c("img", {
              attrs: { src: require("@/assets/image/aigc/full.png"), alt: "" },
              on: { click: _vm.activeFullScreen },
            }),
            _c("img", {
              attrs: { src: require("@/assets/image/aigc/close.png"), alt: "" },
              on: { click: _vm.closeSlideBar },
            }),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "slide-content" },
        [
          _c("chat-frame", {
            ref: "chatFrameRefs",
            staticClass: "chat-frame",
            on: {
              setInput: _vm.setInput,
              createTopic: _vm.createTopic,
              resetAnswer: _vm.resetAnswer,
              openRevision: _vm.openRevision,
              collectSearch: _vm.topicSearch,
            },
          }),
          _c(
            "div",
            { staticClass: "slide-bottom" },
            [
              !_vm.getisDeleted
                ? _c("chat-tools", {
                    on: {
                      restRender: _vm.restRender,
                      handleClick: _vm.handleClick,
                    },
                  })
                : _vm._e(),
              !_vm.getisDeleted
                ? _c("chat-input", {
                    ref: "chatInputRefs",
                    attrs: { content: _vm.activeItemContent },
                    on: { userInput: _vm.userInput },
                  })
                : _c("div", { staticClass: "chatDeletedInput" }, [
                    _vm._v(" 助手已停止使用，请更换其他助手。 "),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("drawer", {
        ref: "topicRef",
        attrs: { type: _vm.drawerType },
        on: {
          selectItem: _vm.selectItem,
          close: function ($event) {
            _vm.visibleDrawer = false
          },
        },
        model: {
          value: _vm.visibleDrawer,
          callback: function ($$v) {
            _vm.visibleDrawer = $$v
          },
          expression: "visibleDrawer",
        },
      }),
      _c("customDialog", {
        attrs: { list: _vm.custonComponentList },
        on: {
          close: function ($event) {
            _vm.visibleCustomDialog = false
          },
        },
        model: {
          value: _vm.visibleCustomDialog,
          callback: function ($$v) {
            _vm.visibleCustomDialog = $$v
          },
          expression: "visibleCustomDialog",
        },
      }),
      _c(
        "drawer",
        { attrs: { visible: !!_vm.getNewsList().length, type: null } },
        [
          _c("NewsList", {
            attrs: {
              width: "432px",
              padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }